import WorkspacesAction from '../actions/workspaces/WorkspacesAction'
import { Workspace } from '../../interfaces/workspaces'

type State = {
  allWorkspaces: Workspace[]
  top5Workspaces: Workspace[]
  workspacesRemaining: number,
  totalWorkspaces: number
}

class WorkspacesReducer {

  private static initialState: State = {
    allWorkspaces: [],
    top5Workspaces: [],
    workspacesRemaining: 0,
    totalWorkspaces: 0
  }

  static reducer = (state = WorkspacesReducer.initialState, action) => {
    switch (action.type) {
           
      case WorkspacesAction.REQUEST_WORKSPACES:
      case WorkspacesAction.REQUEST_ALLWORKSPACES:
        return {
          ...state
        }

      case WorkspacesAction.RECEIVE_WORKSPACES:
        return {
          ...state,
          top5Workspaces: action.payload.workspaces
        }
      case WorkspacesAction.RECEIVE_WORKSPACESNOCOUNTS:
        return {
          ...state,
          allWorkspaces: action.payload.workspaces
      }
      case WorkspacesAction.RECEIVE_REMAININGWORKSPACES:
        return {
          ...state,
          workspacesRemaining: action.payload.remainingWorkspaces,
          totalWorkspaces: action.payload.totalWorkspaces
        }
    }

    return state
  }
}

export default WorkspacesReducer